import { InjectionToken } from '@angular/core';

export const NGX_INTL_DEFAULT_LOCALE = new InjectionToken<string>('ngx.intl.default.locale');
